import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { ErrorText } from "../../../components";
import BootstrapSwitchButton from "bootstrap-switch-button-react";

const TYPES = [
  {
    name: "Android",
    value: "android_phone",
  },
  {
    name: "Iphone",
    value: "iphone_phone",
  },
  {
    name: "Android Tablet",
    value: "android_tablet",
  },
];

export default class VersionModal extends Component {
  constructor() {
    super();
    this.state = this.initState();
  }

  initState = () => ({
    form: {
      version: "",
      platform: "",
      force_upgrade: true,
      versionToDelete: null,
    },
    errors: {},
  });

  onSave = () => {
    if (!this.validateForm()) return;
    const { form } = this.state;
    this.props.addVersion(form);
    this.setState(this.initState());
  };

  validateForm = () => {
    const { form } = this.state;
    const errors = {};

    if (!form.version) errors.version = "Required";
    if (
      form.version === "android_phone" ||
      form.version === "iphone_phone" ||
      form.version === "android_tablet"
    )
      if (!form.force_upgrade) errors.force_upgrade = "Required";

    this.setState({ errors });

    return isEmpty(errors);
  };

  onInputChange = (e) => {
    console.log(e.target);
    const { name, value } = e.target;
    this.setState((state) => ({
      form: {
        ...state.form,
        [name]: value === "force_upgrade" ? e : value,
      },
      errors: {
        ...state.errors,
        [name]: "",
      },
    }));
  };
  onStatusChange = (e) =>{
    this.setState((state) => ({
      form:{
        ...state.form,
        force_upgrade: !state.form.force_upgrade
      }
    }))
  }

  onClose = () => {
    this.setState(this.initState());
    this.props.onHide();
  };

  render() {
    const { form, errors } = this.state;
    const { show, data } = this.props;

    return (
      <Modal
        show={show}
        onHide={this.onClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Version
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-2">
              <div className="form-group">
                <label
                  className={classNames({ "text-danger": errors.version })}
                >
                  Version
                </label>
                <input
                  type="text"
                  name="version"
                  value={form.version}
                  onChange={this.onInputChange}
                  placeholder="version"
                  className={classNames("form-control", {
                    "is-invalid": errors.version,
                  })}
                  maxLength="20"
                />
                <ErrorText error={errors.version} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label
                  className={classNames({ "text-danger": errors.platform })}
                >
                  Platform
                </label>
                <select
                  name="platform"
                  value={form.platform}
                  onChange={this.onInputChange}
                  className={classNames("form-control", {
                    "is-invalid": errors.platform,
                  })}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.name}
                    </option>
                  ))}
                </select>
                <ErrorText error={errors.platform} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label
                  className={classNames("mr-2", {
                    "text-danger": errors.force_upgrade,
                  })}
                >
                  Force Update
                </label>
                <BootstrapSwitchButton
                  checked={form.force_upgrade}
                  name="force_upgrade"
                  onstyle="success"
                  offstyle="danger"
                  size="xs"
                  onChange={this.onStatusChange}
                />

                <ErrorText error={errors.force_upgrade} />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={this.onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={this.onSave}>
            Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
